import { FormattedMessage } from "react-intl";
import List from "app/pages/.shared/List";
import Popover from "app/components/ui/Popover/Popover";
import PropTypes from "prop-types";
import { memo } from "react";
import { ICON_SIZES } from "app/constants";
import SquareLockFilledIcon from "app/icons/navigation/SquareLockFilledIcon";
import "./PaymentSecurityNote.scss";

const PaymentSecurityNote = ({ brandDisplayName }) => {
	return (
		<div className="payment-security-note">
			<SquareLockFilledIcon size={ICON_SIZES.XXS} />
			<FormattedMessage id="payment.security.full" />

			<Popover
				iconSize={15}
				iconStyle={{ marginLeft: "4px" }}
				dataTestId="payment-security-note-icon"
			>
				<List
					className="payment-security-note__list"
					items={[
						<FormattedMessage
							id="payment.security.note.1"
							key="payment.security.note.1"
						/>,
						<FormattedMessage
							id="payment.security.note.2"
							key="payment.security.note.2"
						/>,
						<FormattedMessage
							id="payment.security.note.3"
							key="payment.security.note.3"
							values={{
								brandName: brandDisplayName,
							}}
						/>,
					]}
				/>
			</Popover>
		</div>
	);
};

PaymentSecurityNote.propTypes = {
	brandDisplayName: PropTypes.string,
};
export default memo(PaymentSecurityNote);
